import { Card, Chip, Link, Tab, Table, Typography } from '@mui/joy'
import React from 'react'

function TarifTable({ data, tablename, kathid }) {
  return (
    <>
      <Table sx={{ '& thead th:nth-child(1)': { width: "45%" }, mt: 5 }}>
        <thead>
          <tr>
            <th>{tablename}</th>
            <th>Gesellschaft</th>
            <th>Sonstiges</th>
          </tr>
        </thead>
        <tbody>
          {
            [...data] // Kopie, um Original nicht zu verändern
              .sort((a, b) => b.name.localeCompare(a.name)) // Absteigend
              .map((item) => (
                <tr key={item.id}>
                  <td><Link href={"/tarif/" + item.id + "/" + kathid}>{item.name}</Link></td>

                  <td><Chip color="success">{item.gesellschaft}</Chip></td>
                  <td>
                    {item.emty && (
                      <Chip color="danger">
                        Leerer Tarif
                      </Chip>
                    )}
                    {
                      item.alttarif && (
                        <Chip color='sucsess'>AltTarif</Chip>

                      )
                    }
                  </td>
                </tr>
              ))
          }


        </tbody>
      </Table>


    </>
  )
}

export default TarifTable
